export const containerTheme = {
  baseStyle: { maxW: 'app' },
};
